import { Model } from "@/models/Model";
import FallbackDB from "@/libraries/indexedDB";
export class ModelIndexedDB extends Model {
    constructor(table, id = null) {
        super();
        this.table = table;
        this._id = id;
    }
    async init() {
        if (!this._id) {
            return;
        }
        this.setData(await this.getDataFromDB(this._id));
    }
    getDataFromDB(id) {
        return FallbackDB.findOne(this.table, id);
    }
    setDataToDB(id) {
        FallbackDB.saveOne(this.table, id, this.getData());
    }
    getTableData() {
        return FallbackDB.restore(this.table);
    }
    setTableData(data) {
        FallbackDB.save(this.table, data);
    }
}
